import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Rubik\",\"arguments\":[{\"subsets\":[\"hebrew\",\"latin\"],\"variable\":\"--font-platform\"}],\"variableName\":\"rubik\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProviders"] */ "/vercel/path0/src/lib/providers/globalProviders.tsx");
